import translation from "./translation";


const MockData = {
    translation,
}


export default MockData;